import styled from 'styled-components'

export const ServiceCardContainer = styled.div`
  margin-top: 50px;
`

export const ServiceCard = styled.a`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 44px;
  width: 100%;
  background-color: #ffffff;
  gap: 8px;
  padding: 0px 8px 0px 8px;
  border-radius: 8px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.06), 0px 3px 3px rgba(0, 0, 0, 0.04);
`
export const ServiceImg = styled.div``

export const ServiceText = styled.div`
  color: #131717;
  font-size: 16px;
  font-weight: 400;
`

export const FlightSvg = styled.div`
  > svg > g > g {
    fill: #2dc44d;
  }
`
export const HotelSvg = styled.div`
  > svg {
    color: #ff3b42;
  }
`
export const BusSvg = styled.div`
  > svg {
    fill: #0087ff;
  }
`
export const CarSvg = styled.div`
  > svg > g > g {
    fill: #4f1bb7;
  }
`
export const CarTimeSvg = styled.div`
  > svg,
  rect,
  ellipse,
  path:last-child {
    color: #9966ff;
    fill: #9966ff;
  }
`
export const DepositFullSvg = styled.div`
  > svg {
    color: #eaa61a;
  }
`
export const TravelInsuranceSvg = styled.div`
  > svg > g > g {
    fill: #004787;
  }
`
export const FinanceSvg = styled.div`
  > svg {
    color: #1b2f6f;
  }
`
export const InternetSvg = styled.div`
  > svg > g > g {
    fill: #b20006;
  }
`
export const GsmSvg = styled.div`
  > svg {
    color: #2d7fc4;
  }
`
export const GiftCardSvg = styled.div`
  > svg {
    fill: #ff757a;
  }
`
export const CreditSvg = styled.div`
  > svg {
    color: #021141;
  }
`
